module.exports = __webpack_public_path__ + "img/weixin-tyb.d6226abd.png";